export const GET_REGIONS = 'GET_REGIONS';